import { useState } from 'react';
import axios from 'axios';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';

export const usePatchSkill = () => {
  const [skill, setSkill] = useState();
  const [loadingSkill, setLoadingSkill] = useState<boolean>();

  const patchSkill = async (
    skillToEditId: string,
    level: string,
    attitude: string
  ) => {
    if (loadingSkill) return;

    try {
      setLoadingSkill(true);
      const { data } = await axios.patch('api/employee-skills/my', {
        id: skillToEditId,
        level: { value: level },
        attitude: { value: attitude },
      });
      data && setSkill(data);
      analyticsEventSend('Edit skill request posted');
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingSkill(false);
    }
  };

  return { skill, loadingSkill, patchSkill };
};
